import { View } from 'es6/components/view'

export class BaseCarouselView extends View {
  /**
   * Собираем данные об активном слайде и отправляем в шину событий
   * @param {Event} event Событие.
   */
  sendDataToEventBus (event) {
    if (this.eventBus) {
      this.eventBus.trigger('carousel.changed.item', this.getCurrentItem(event))
    }
  }

  /**
   * Метод для получения активного слайда
   * @param {Event} [event] Событие.
   */
  getCurrentItem (event) {
    throw new Error('Method BaseCarouselView._getCurrentItem is not implemented in descendants.')
  }
}
